export const COMPANY_NAME = "Aura Capital LLC";
export const COMPANY_SHORT = "Aura Capital";
export const COMPANY_INITIALS = "AC";
export const COMPANY_ADDRESS_FULL = "52 Majeza Ct, Rancho Mission Viejo, California, US 92694-1593";
export const COMPANY_LOCATION = "California, US";
export const COMPANY_REGION = "California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=52%20Majeza%20Ct%2C%20Rancho%20Mission%20Viejo%2C%20California%2C%20US%2092694-1593";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Public profile" },
  { "label": "Service Area", "value": "California" },
  { "label": "Location", "value": "California, US" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Aura Capital LLC" },
  { "label": "City / State", "value": "California, US" },
  { "label": "Address", "value": "52 Majeza Ct, Rancho Mission Viejo, California, US 92694-1593" },
];
